import { render, staticRenderFns } from "./CSBRooms.vue?vue&type=template&id=7a6928be&scoped=true&"
import script from "./CSBRooms.vue?vue&type=script&lang=js&"
export * from "./CSBRooms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6928be",
  null
  
)

export default component.exports